import React, { useEffect, useState } from "react";
import {
  ChangeTitle,
  DeletSweetAlert,
  selectFormStyle,
  toAbsoluteUrl,
  toasterrormsg,
  toastsuccessmsg,
} from "../../helpers/Reusable";
import * as Yup from "yup";
import { useFormik } from "formik";
import { ToastContainer } from "react-toastify";
import ClipLoader from "react-spinners/ClipLoader";
import { IoClose } from "react-icons/io5";
import Select from "react-select";
import {
  apiHeader,
  deleteData,
  getData,
  postData,
} from "../../helpers/ApiHelper";

const onlyIntRegExp = /^[0-9+]+$/;
const onlyAlphabet = /^[A-Za-z][A-Za-z\s]+$/;

// Formik InitialValues
const initialValues = {
  addressId: "",
  fullName: "",
  mobileNumber: "",
  designation: "",
  companyName: "",
  flatFloorNo: "",
  streetRoadNo: "",
  location: "",
  country: "",
  pinCode: "",
  city: "",
  addressType: "",
};

// Fromik Validation Schema
const schema = Yup.object().shape({
  fullName: Yup.string()
    .trim()
    .required("Full name is required")
    .matches(onlyAlphabet, "Full name is not valid"),
  mobileNumber: Yup.string()
    .trim()
    .required("Mobile number is required")
    .matches(onlyIntRegExp, "Mobile number is not valid")
    .min(10, "Mobile number is not valid")
    .max(16, "Mobile number is not valid"),
  designation: Yup.string().trim().required("Select designation"),
  // companyName: Yup.string()
  //   .trim()
  //   .required("Company Name is required")
  //   .matches(onlyAlphabet, "Company Name is not valid"),
  // flatFloorNo: Yup.string().trim().required("Flat / Floor No. is required"),
  // streetRoadNo: Yup.string().trim().required("Street / Road No. is required"),
  // location: Yup.string().trim().required("Location is required"),
  country: Yup.string().trim().required("Select country"),
  pinCode: Yup.string()
    .trim()
    .required("Pin code is required")
    .matches(onlyIntRegExp, "Pin code is not valid")
    .min(4, "Pin code is not valid")
    .max(14, "Pin code is not valid"),
  city: Yup.string().trim().required("City is required"),
  addressType: Yup.string().trim().required("Select address type"),
});

const BigScreenAddress = () => {
  const [loading, setLoading] = useState(false);
  const [addressList, setAddressList] = useState([]);
  const [designationList, setDesignationList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  // Add Address Api Call

  const formik = useFormik({
    initialValues,
    validationSchema: schema,
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);

      const param = {
        addressId: values.addressId,
        fullName: values.fullName,
        mobileNumber: values.mobileNumber,
        designationId: values.designation,
        companyName: values.companyName,
        flatFloorNo: values.flatFloorNo,
        streetRoadNo: values.streetRoadNo,
        location: values.location,
        countryId: values.country,
        pincode: values.pinCode,
        city: values.city,
        addressType: values.addressType, //"default","home","office"
      };

      console.log(param);

      const response = await postData(
        "private/user/address",
        param,
        apiHeader(false)
      );

      if (
        String(response?.status) == "200" &&
        String(response?.data.status) == "200"
      ) {
        toastsuccessmsg(response.data.message);
        viewAddressList();
        setTimeout(() => {
          setLoading(false);
          resetForm();
        }, 1500);
      } else {
        console.log(response.data.message);
        toasterrormsg(response.data.message);
        setLoading(false);
      }
    },
  });

  // Address API Call
  const viewAddressList = async () => {
    const param = {};
    var response = await getData(
      "private/user/address/list",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data;
      setAddressList(data);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Get Address API Call
  const getAddressDetail = async (id) => {
    const param = {
      addressId: id,
    };
    var response = await postData(
      "private/user/address/detail",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data;
      formik.setValues({
        addressId: data._id,
        fullName: data.fullName,
        mobileNumber: data.mobileNumber,
        designation: data.designationId,
        companyName: data.companyName,
        flatFloorNo: data.flatFloorNo,
        streetRoadNo: data.streetRoadNo,
        location: data.location,
        country: data.countryId,
        pinCode: data.pincode,
        city: data.city,
        addressType: data.addressType,
      });
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Address Delete API Call
  const deleteAddress = async (id) => {
    const result = await DeletSweetAlert();
    if (result.isConfirmed) {
      const param = {
        addressId: id,
      };
      console.log(param, "param");

      var response = await deleteData(
        "private/user/address/delete",
        param,
        apiHeader(false)
      );
      console.log(response);

      if (
        String(response?.status) == "200" &&
        String(response?.data.status) == "200"
      ) {
        toastsuccessmsg(response.data.message);
        viewAddressList();
      } else {
        console.log(response.data);
        console.log(response.data.message);
      }
    }
  };

  // Designation API Call
  const viewDesignationList = async () => {
    const param = {};
    var response = await postData("designation/list", param, apiHeader(false));

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const listData = data.map((data) => {
        return {
          value: data._id,
          label: data.designationName,
        };
      });
      setDesignationList(listData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // County List  API Call
  const viewCountryList = async () => {
    const param = {};
    var response = await getData(
      "private/country/list",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const listData = data.map((data) => {
        return {
          value: data._id,
          label: data.countryName,
        };
      });
      setCountryList(listData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  useEffect(() => {
    viewAddressList();
    viewDesignationList();
    viewCountryList();
  }, []);

  return (
    <div className="w-full xxl:container mx-auto ">
      <div className="flex gap-[3rem]">
        <div className="w-[50%] bg-white h-max px-[3rem] pt-[3rem] billing-address">
          <div className="w-full mb-[1%] flex items-center justify-between">
            <h1>Addresses</h1>
          </div>
          {addressList.length != 0 ? (
            addressList.map((data) => (
              <div className="flex justify-between items-start gap-5 mb-[3rem] w-full px-[1rem] py-[1rem] ba-box">
                <div className="w-full flex justify-between items-start">
                  <div className="w-[70%]">
                    <h1 className="mb-[1%] name">{data.fullName}</h1>
                    <h3 className="mb-[1%] address">
                      {data.flatFloorNo}, {data.streetRoadNo}, {data.location},{" "}
                      {data.city}, {data.countryDetail.countryName} -{" "}
                      {data.pincode}
                    </h3>
                    <h3 className="mobileno">{data.mobileNumber}</h3>
                  </div>
                  <div className="w-auto flex gd-icon">
                    <button
                      onClick={() => {
                        getAddressDetail(data._id);
                      }}
                    >
                      <img
                        className="p-[1rem] w-max mr-[2%] cursor-pointer"
                        src={toAbsoluteUrl("media/img/icon/basic/pencile.svg")}
                        alt=""
                      />
                    </button>
                    <button onClick={() => deleteAddress(data._id)}>
                      <img
                        className="p-[1rem] w-max mr-[2%] cursor-pointer"
                        src={toAbsoluteUrl("media/img/icon/basic/trash.svg")}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <>
              <h3 className="mb-[1%] text-center no-found">No address found</h3>
            </>
          )}
        </div>
        <div className="w-[50%] p-[3rem] form-box">
          <form onSubmit={formik.handleSubmit}>
            <div className="w-full grid grid-cols-1 gap-[2rem] gap-y-[2rem] mb-[5rem]">
              <div className="w-full flex flex-col">
                <label
                  htmlFor=""
                  className="w-full form-input-label required mb-4"
                >
                  Full name
                </label>
                <input
                  className="w-full form-input"
                  type="text"
                  placeholder="Enter full name"
                  name="fullName"
                  id="fullName"
                  value={formik.values.fullName}
                  onChange={formik.handleChange}
                />
                {formik.touched.fullName && formik.errors.fullName && (
                  <div className="mt-2 error-msg">
                    <div className="">{formik.errors.fullName}</div>
                  </div>
                )}
              </div>
              <div className="w-full flex flex-col">
                <label
                  htmlFor=""
                  className="w-full form-input-label required mb-4"
                >
                  Mobile number
                </label>
                <input
                  className="w-full form-input"
                  type="text"
                  placeholder="Enter mobile number"
                  id="mobileNumber"
                  value={formik.values.mobileNumber}
                  onChange={formik.handleChange}
                />
                {formik.touched.mobileNumber && formik.errors.mobileNumber && (
                  <div className="mt-2 error-msg">
                    <div className="">{formik.errors.mobileNumber}</div>
                  </div>
                )}
              </div>
              <div className="w-full flex flex-col">
                <label
                  htmlFor=""
                  className="w-full form-input-label required mb-4"
                >
                  Designation
                </label>
                <Select
                  name="designation"
                  id="designation"
                  placeholder="Select designation"
                  className="w-full form-select form-input"
                  isSearchable={true}
                  options={designationList}
                  value={
                    designationList.find(
                      (item) => item.value === formik.values.designation
                    ) || ""
                  }
                  onChange={(e) => formik.setFieldValue("designation", e.value)}
                  styles={selectFormStyle}
                />
                {formik.touched.designation && formik.errors.designation && (
                  <div className="mt-2 error-msg">
                    <div className="">{formik.errors.designation}</div>
                  </div>
                )}
              </div>
              <div className="w-full flex flex-col">
                <label
                  htmlFor=""
                  className="w-full form-input-label mb-4"
                >
                  Company name
                </label>
                <input
                  className="w-full form-input"
                  type="text"
                  placeholder="Enter company name"
                  name="companyName"
                  id="companyName"
                  value={formik.values.companyName}
                  onChange={formik.handleChange}
                />
                {formik.touched.companyName && formik.errors.companyName && (
                  <div className="mt-2 error-msg">
                    <div className="">{formik.errors.companyName}</div>
                  </div>
                )}
              </div>
              <div className="w-full flex flex-col">
                <label
                  htmlFor=""
                  className="w-full form-input-label mb-4"
                >
                  Flat / Floor no.
                </label>
                <input
                  className="w-full form-input"
                  type="text"
                  placeholder="Enter flat / floor no"
                  name="flatFloorNo"
                  id="flatFloorNo"
                  value={formik.values.flatFloorNo}
                  onChange={formik.handleChange}
                />
                {formik.touched.flatFloorNo && formik.errors.flatFloorNo && (
                  <div className="mt-2 error-msg">
                    <div className="">{formik.errors.flatFloorNo}</div>
                  </div>
                )}
              </div>
              <div className="w-full flex flex-col">
                <label
                  htmlFor=""
                  className="w-full form-input-label mb-4"
                >
                  Street / Road no
                </label>
                <input
                  className="w-full form-input"
                  type="text"
                  placeholder="Enter street / road no"
                  name="streetRoadNo"
                  id="streetRoadNo"
                  value={formik.values.streetRoadNo}
                  onChange={formik.handleChange}
                />
                {formik.touched.streetRoadNo && formik.errors.streetRoadNo && (
                  <div className="mt-2 error-msg">
                    <div className="">{formik.errors.streetRoadNo}</div>
                  </div>
                )}
              </div>
              <div className="w-full flex flex-col">
                <label
                  htmlFor=""
                  className="w-full form-input-label mb-4"
                >
                  Location
                </label>
                <input
                  className="w-full form-input"
                  type="text"
                  placeholder="Enter location"
                  name="location"
                  id="location"
                  value={formik.values.location}
                  onChange={formik.handleChange}
                />
                {formik.touched.location && formik.errors.location && (
                  <div className="mt-2 error-msg">
                    <div className="">{formik.errors.location}</div>
                  </div>
                )}
              </div>
              <div className="w-full flex flex-col">
                <label
                  htmlFor=""
                  className="w-full form-input-label required mb-4"
                >
                  Country
                </label>
                <Select
                  name="country"
                  id="country"
                  placeholder="Select country"
                  className="w-full form-select form-input"
                  isSearchable={true}
                  options={countryList}
                  value={
                    countryList.find(
                      (item) => item.value === formik.values.country
                    ) || ""
                  }
                  onChange={(e) => formik.setFieldValue("country", e.value)}
                  styles={selectFormStyle}
                />
                {formik.touched.country && formik.errors.country && (
                  <div className="mt-2 error-msg">
                    <div className="">{formik.errors.country}</div>
                  </div>
                )}
              </div>
              <div className="w-full flex flex-col">
                <label
                  htmlFor=""
                  className="w-full form-input-label required mb-4"
                >
                  Pin code
                </label>
                <input
                  className="w-full form-input"
                  type="text"
                  placeholder="Enter pin code"
                  id="pinCode"
                  value={formik.values.pinCode}
                  onChange={formik.handleChange}
                />
                {formik.touched.pinCode && formik.errors.pinCode && (
                  <div className="mt-2 error-msg">
                    <div className="">{formik.errors.pinCode}</div>
                  </div>
                )}
              </div>
              <div className="w-full flex flex-col">
                <label
                  htmlFor=""
                  className="w-full form-input-label required mb-4"
                >
                  City
                </label>
                <input
                  className="w-full form-input"
                  type="text"
                  placeholder="Enter city"
                  name="city"
                  id="city"
                  value={formik.values.city}
                  onChange={formik.handleChange}
                />
                {formik.touched.city && formik.errors.city && (
                  <div className="mt-2 error-msg">
                    <div className="">{formik.errors.city}</div>
                  </div>
                )}
              </div>
              <div className="w-full flex flex-col">
                <div className="w-full flex flex-wrap flex-row gap-5 md:gap-10 mb-auto">
                  <div className="flex gap-3 items-center form-checkbox">
                    <input
                      type="radio"
                      name="addressType"
                      value="default"
                      checked={formik.values.addressType === "default"}
                      onChange={() =>
                        formik.setFieldValue("addressType", "default")
                      }
                      className="appearance-none w-[2rem] h-[2rem] border-4 border-[#f0f0f0] rounded-full checked:border-[#c99930] checked:bg-transparent checked:ring-[#c99930] bg-[#f0f0f0]"
                    />
                    <label htmlFor="" className="checkbox-label">
                      This is my default address
                    </label>
                  </div>
                  <div className="flex gap-3 items-center form-checkbox">
                    <input
                      type="radio"
                      name="addressType"
                      value="home"
                      checked={formik.values.addressType === "home"}
                      onChange={() =>
                        formik.setFieldValue("addressType", "home")
                      }
                      className="appearance-none w-[2rem] h-[2rem] border-4 border-[#f0f0f0] rounded-full checked:border-[#c99930] checked:bg-transparent checked:ring-[#c99930] bg-[#f0f0f0]"
                    />
                    <label htmlFor="" className="checkbox-label">
                      Home
                    </label>
                  </div>
                  <div className="flex gap-3 items-center form-checkbox">
                    <input
                      type="radio"
                      name="addressType"
                      value="office"
                      checked={formik.values.addressType === "office"}
                      onChange={() =>
                        formik.setFieldValue("addressType", "office")
                      }
                      className="appearance-none w-[2rem] h-[2rem] border-4 border-[#f0f0f0] rounded-full checked:border-[#c99930] checked:bg-transparent checked:ring-[#c99930] bg-[#f0f0f0]"
                    />
                    <label htmlFor="" className="checkbox-label">
                      Office
                    </label>
                  </div>
                </div>
                {formik.touched.addressType && formik.errors.addressType && (
                  <div className="mt-2 error-msg">
                    <div className="">{formik.errors.addressType}</div>
                  </div>
                )}
              </div>
            </div>
            <div className="w-full justify-center gap-5 flex">
              <button type="submit" className="btn-submit" disabled={loading}>
                {!loading && <>{formik.values.addressId ? "Update" : "Save"}</>}
                {loading && (
                  <div className="flex items-center gap-3">
                    <span className="" style={{ display: "block" }}>
                      Please wait...{" "}
                    </span>
                    <ClipLoader
                      color={"#ffffff"}
                      loading={loading}
                      size={20}
                      aria-label="Loading Spinner"
                      data-testid="loader"
                    />
                  </div>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

const SmallScreenAddress = () => {
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [addressList, setAddressList] = useState([]);
  const [designationList, setDesignationList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  // Add Address Api Call

  const formik = useFormik({
    initialValues,
    validationSchema: schema,
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);

      const param = {
        addressId: values.addressId,
        fullName: values.fullName,
        mobileNumber: values.mobileNumber,
        designationId: values.designation,
        companyName: values.companyName,
        flatFloorNo: values.flatFloorNo,
        streetRoadNo: values.streetRoadNo,
        location: values.location,
        countryId: values.country,
        pincode: values.pinCode,
        city: values.city,
        addressType: values.addressType, //"default","home","office"
      };

      console.log(param);

      const response = await postData(
        "private/user/address",
        param,
        apiHeader(false)
      );

      if (
        String(response?.status) == "200" &&
        String(response?.data.status) == "200"
      ) {
        toastsuccessmsg(response.data.message);
        viewAddressList();
        setTimeout(() => {
          setLoading(false);
          resetForm();
          closeModal();
        }, 1500);
      } else {
        console.log(response.data.message);
        toasterrormsg(response.data.message);
        setLoading(false);
      }
    },
  });

  // Address API Call
  const viewAddressList = async () => {
    const param = {};
    var response = await getData(
      "private/user/address/list",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data;
      setAddressList(data);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Get Address API Call
  const getAddressDetail = async (id) => {
    const param = {
      addressId: id,
    };
    var response = await postData(
      "private/user/address/detail",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data;
      formik.setValues({
        addressId: data._id,
        fullName: data.fullName,
        mobileNumber: data.mobileNumber,
        designation: data.designationId,
        companyName: data.companyName,
        flatFloorNo: data.flatFloorNo,
        streetRoadNo: data.streetRoadNo,
        location: data.location,
        country: data.countryId,
        pinCode: data.pincode,
        city: data.city,
        addressType: data.addressType,
      });
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Address Delete API Call
  const deleteAddress = async (id) => {
    const result = await DeletSweetAlert();
    if (result.isConfirmed) {
      const param = {
        addressId: id,
      };
      console.log(param, "param");

      var response = await deleteData(
        "private/user/address/delete",
        param,
        apiHeader(false)
      );
      console.log(response);

      if (
        String(response?.status) == "200" &&
        String(response?.data.status) == "200"
      ) {
        toastsuccessmsg(response.data.message);
        viewAddressList();
      } else {
        console.log(response.data);
        console.log(response.data.message);
      }
    }
  };

  // Designation API Call
  const viewDesignationList = async () => {
    const param = {};
    var response = await postData("designation/list", param, apiHeader(false));

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const listData = data.map((data) => {
        return {
          value: data._id,
          label: data.designationName,
        };
      });
      setDesignationList(listData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // County List  API Call
  const viewCountryList = async () => {
    const param = {};
    var response = await getData(
      "private/country/list",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const listData = data.map((data) => {
        return {
          value: data._id,
          label: data.countryName,
        };
      });
      setCountryList(listData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  useEffect(() => {
    viewAddressList();
    viewDesignationList();
    viewCountryList();
  }, []);

  // Opem Modal Popup Form Function
  const openModal = () => {
    document.body.style.overflowY = "hidden";
    setIsModalOpen(true);
  };
  // Close Modal Popup Form Function
  const closeModal = () => {
    document.body.style.overflowY = "";
    setIsModalOpen(false);
    formik.resetForm();
  };

  return (
    <>
      {isModalOpen === true && (
        <>
          <div
            onClick={() => closeModal()}
            className={`w-full fixed top-0 left-0 z-[9999] h-screen overflow-x-hidden overflow-y-auto bg-form getintouch`}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="w-[90%] md:w-[80%] lg:w-[70%] xl:w-[60%] xxl:container p-[2%] mx-auto my-[6%] relative  transform form-box"
            >
              <div className="flex items-center justify-between">
                <h1 className="mb-[3%] hanson">Address</h1>
                <IoClose
                  onClick={() => closeModal("address")}
                  className="w-[3rem] h-[3rem] cursor-pointer"
                />
              </div>
              <div className="">
                <form onSubmit={formik.handleSubmit}>
                  <div className="w-full grid lg:grid-cols-2 gap-[2rem] gap-y-[1rem] mb-[2rem]">
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Full name
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter full name"
                        name="fullName"
                        id="fullName"
                        value={formik.values.fullName}
                        onChange={formik.handleChange}
                      />
                      {formik.touched.fullName && formik.errors.fullName && (
                        <div className="mt-2 error-msg">
                          <div className="">{formik.errors.fullName}</div>
                        </div>
                      )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Mobile number
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter mobile number"
                        id="mobileNumber"
                        value={formik.values.mobileNumber}
                        onChange={formik.handleChange}
                      />
                      {formik.touched.mobileNumber &&
                        formik.errors.mobileNumber && (
                          <div className="mt-2 error-msg">
                            <div className="">{formik.errors.mobileNumber}</div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Designation
                      </label>
                      <Select
                        name="designation"
                        id="designation"
                        placeholder="Select designation"
                        className="w-full form-select form-input"
                        isSearchable={true}
                        options={designationList}
                        value={designationList.find(
                          (item) => item.value === formik.values.designation
                        )}
                        onChange={(e) =>
                          formik.setFieldValue("designation", e.value)
                        }
                        styles={selectFormStyle}
                      />
                      {formik.touched.designation &&
                        formik.errors.designation && (
                          <div className="mt-2 error-msg">
                            <div className="">{formik.errors.designation}</div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label mb-4"
                      >
                        Company name
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter company name"
                        name="companyName"
                        id="companyName"
                        value={formik.values.companyName}
                        onChange={formik.handleChange}
                      />
                      {formik.touched.companyName &&
                        formik.errors.companyName && (
                          <div className="mt-2 error-msg">
                            <div className="">{formik.errors.companyName}</div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label mb-4"
                      >
                        Flat / Floor no.
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter flat / floor no"
                        name="flatFloorNo"
                        id="flatFloorNo"
                        value={formik.values.flatFloorNo}
                        onChange={formik.handleChange}
                      />
                      {formik.touched.flatFloorNo &&
                        formik.errors.flatFloorNo && (
                          <div className="mt-2 error-msg">
                            <div className="">{formik.errors.flatFloorNo}</div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label mb-4"
                      >
                        Street / Road no
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter street / road no"
                        name="streetRoadNo"
                        id="streetRoadNo"
                        value={formik.values.streetRoadNo}
                        onChange={formik.handleChange}
                      />
                      {formik.touched.streetRoadNo &&
                        formik.errors.streetRoadNo && (
                          <div className="mt-2 error-msg">
                            <div className="">{formik.errors.streetRoadNo}</div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label mb-4"
                      >
                        Location
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter location"
                        name="location"
                        id="location"
                        value={formik.values.location}
                        onChange={formik.handleChange}
                      />
                      {formik.touched.location && formik.errors.location && (
                        <div className="mt-2 error-msg">
                          <div className="">{formik.errors.location}</div>
                        </div>
                      )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Country
                      </label>
                      <Select
                        name="country"
                        id="country"
                        placeholder="Select country"
                        className="w-full form-select form-input"
                        isSearchable={true}
                        options={countryList}
                        value={countryList.find(
                          (item) => item.value === formik.values.country
                        )}
                        onChange={(e) =>
                          formik.setFieldValue("country", e.value)
                        }
                        styles={selectFormStyle}
                      />
                      {formik.touched.country && formik.errors.country && (
                        <div className="mt-2 error-msg">
                          <div className="">{formik.errors.country}</div>
                        </div>
                      )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Pin code
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter pin code"
                        id="pinCode"
                        value={formik.values.pinCode}
                        onChange={formik.handleChange}
                      />
                      {formik.touched.pinCode && formik.errors.pinCode && (
                        <div className="mt-2 error-msg">
                          <div className="">{formik.errors.pinCode}</div>
                        </div>
                      )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        City
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter city"
                        name="city"
                        id="city"
                        value={formik.values.city}
                        onChange={formik.handleChange}
                      />
                      {formik.touched.city && formik.errors.city && (
                        <div className="mt-2 error-msg">
                          <div className="">{formik.errors.city}</div>
                        </div>
                      )}
                    </div>
                    <div className="w-full lg:col-span-2 flex flex-col">
                      <div className="w-full flex flex-wrap flex-row gap-5 md:gap-10 mb-auto">
                        <div className="flex gap-3 items-center form-checkbox">
                          <input
                            type="radio"
                            name="addressType"
                            value="default"
                            checked={formik.values.addressType === "default"}
                            onChange={() =>
                              formik.setFieldValue("addressType", "default")
                            }
                            className="w-[2rem] h-[2rem] form-input accent-[#2C3451]"
                          />
                          <label htmlFor="" className="checkbox-label">
                            This is my default address
                          </label>
                        </div>
                        <div className="flex gap-3 items-center form-checkbox">
                          <input
                            type="radio"
                            name="addressType"
                            value="home"
                            checked={formik.values.addressType === "home"}
                            onChange={() =>
                              formik.setFieldValue("addressType", "home")
                            }
                            className="w-[2rem] h-[2rem] form-input accent-[#2C3451]"
                          />
                          <label htmlFor="" className="checkbox-label">
                            Home
                          </label>
                        </div>
                        <div className="flex gap-3 items-center form-checkbox">
                          <input
                            type="radio"
                            name="addressType"
                            value="office"
                            checked={formik.values.addressType === "office"}
                            onChange={() =>
                              formik.setFieldValue("addressType", "office")
                            }
                            className="w-[2rem] h-[2rem] form-input accent-[#2C3451]"
                          />
                          <label htmlFor="" className="checkbox-label">
                            Office
                          </label>
                        </div>
                      </div>
                      {formik.touched.addressType &&
                        formik.errors.addressType && (
                          <div className="mt-2 error-msg">
                            <div className="">{formik.errors.addressType}</div>
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="w-full justify-center gap-5 flex">
                    <button
                      type="submit"
                      className="btn-submit"
                      disabled={loading}
                    >
                      {!loading && <>Save</>}
                      {loading && (
                        <div className="flex items-center gap-3">
                          <span className="" style={{ display: "block" }}>
                            Please wait...{" "}
                          </span>
                          <ClipLoader
                            color={"#ffffff"}
                            loading={loading}
                            size={20}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                          />
                        </div>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </>
      )}
      <div className="w-full xxl:container mx-auto">
        <div className="w-full">
          <div className="w-full bg-white h-max p-[2rem] mb-[3rem]">
            <div className="w-full mb-[1%] flex items-center justify-between">
              <h1 className="title-manage">Manage address</h1>
              <button
                type="button"
                className="btn-add"
                onClick={() => openModal()}
              >
                Add new
              </button>
            </div>
          </div>
          <div className="w-full bg-white h-max px-[2rem] pt-[2rem] pb-[1%] billing-address">
            <div className="w-full mb-[1%] flex items-center justify-between">
              <h1>Addresses</h1>
            </div>
            {addressList.length != 0 ? (
              addressList.map((data) => (
                <div className="flex justify-between items-start gap-5 mb-[3rem] w-full px-[1rem] py-[1rem] ba-box">
                  <div className="w-full flex justify-between items-start">
                    <div className="w-[70%]">
                      <h1 className="mb-[1%] name">{data.fullName}</h1>
                      <h3 className="mb-[1%] address">
                        {data.flatFloorNo}, {data.streetRoadNo}, {data.location}
                        , {data.city}, {data.countryDetail.countryName} -{" "}
                        {data.pincode}
                      </h3>
                      <h3 className="mobileno">{data.mobileNumber}</h3>
                    </div>
                    <div className="w-auto flex gd-icon">
                      <button
                        onClick={() => {
                          getAddressDetail(data._id);
                          openModal();
                        }}
                      >
                        <img
                          className="p-[1rem] w-max mr-[2%] cursor-pointer"
                          src={toAbsoluteUrl(
                            "media/img/icon/basic/pencile.svg"
                          )}
                          alt=""
                        />
                      </button>
                      <button onClick={() => deleteAddress(data._id)}>
                        <img
                          className="p-[1rem] w-max mr-[2%] cursor-pointer"
                          src={toAbsoluteUrl("media/img/icon/basic/trash.svg")}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <>
                <h3 className="mb-[1%] text-center no-found">
                  No address found
                </h3>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

const Address = () => {
  ChangeTitle("My Address");

  return (
    <>
      <ToastContainer />
      <div className="w-full p-[5%] min-h-screen bg-yellow">
        <div className="xxl:container mx-auto">
          <div className="w-full mb-[5%] md:mb-[2%]">
            <h1 className="hanson text-center mb-[1%] heading">
              Shipping address
            </h1>
            <img
              className="mb-[2%] mx-auto"
              src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
              alt=""
            />
          </div>
          <div className="w-full hidden lg:block">
            <BigScreenAddress />
          </div>
          <div className="w-full block lg:hidden">
            <SmallScreenAddress />
          </div>
        </div>
      </div>
    </>
  );
};

export default Address;
